// extracted by mini-css-extract-plugin
export var container = "_5s-0";
export var infoButton = "_5s-1";
export var label = "_5s-3";
export var labelExpanded = "_5s-4";
export var price = "_5s-5";
export var priceExpanded = "_5s-6";
export var title = "_5s-2";